import styled from 'styled-components';
import { SectionLayout } from 'components/Sections/SectionLayout';

const StyledSectionLayout = styled(SectionLayout)`
  .in-page-features--navigation-content {
    position: relative;

    .slick-track {
      -ms-overflow-style: none;
      scrollbar-width: thin;
      overflow: auto;

      &::-webkit-scrollbar {
        display: none;
      }
    }

    .slick-slide {
      padding-right: 40px;

      &:first-child {
        padding-left: 0;
      }
    }

    &::before,
    &::after {
      content: ' ';
      width: 30px;
      position: absolute;
      height: 100%;
      top: 0;
      z-index: 2;
    }

    &::after {
      background: linear-gradient(to right, #ffffff00, #ffffffff);
      right: 0;
    }

    .slick-arrow {
      height: 32px;
      width: 32px;
      z-index: 9;

      &.slick-prev {
        left: -44px;
      }

      &.slick-next {
        right: -44px;
      }

      svg {
        height: 14px;
        width: 14px;
        font-size: 12px;
        min-width: 14px;
      }
    }

    @media (max-width: 1350px) {
      .slick-slide {
        padding: 0 10px;

        &:first-child {
          padding-left: 10px;
        }
      }

      .slick-arrow {
        display: none;
      }

      &::before,
      &::after {
        width: 15px;
      }

      &::before {
        background: linear-gradient(to left, #ffffff00, #ffffffff);
        left: 0;
      }
    }
  }

  .website-image {
    display: flex;
    justify-content: center;
  }

  img {
    max-width: 100%;
    max-height: 720px;
    margin: auto;

    &.slick-disabled {
      display: none !important;
    }

    @media (max-width: 767px) {
      max-height: 335px;
    }
  }
`;

export default StyledSectionLayout;
